"use strict";
import('./bootstrap').catch((err) => console.error(err));
//# sourceMappingURL=main.js.map